import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { InitUser, SetUserSignInFlag } from 'src/app/core/store/user/user.actions';
import { asFormControl } from 'src/app/core/utils/common';
import { notCcsmedEmail } from 'src/app/core/utils/validators';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
})
export class LoginFormComponent implements OnInit {
  @Input() username: string = '';
  @Input() updateUsername!: (username: string) => void;
  @Input() forgotPassword!: () => void;
  @Input() signInWithCode!: () => void;

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email, notCcsmedEmail()]),
    password: new FormControl('', Validators.required),
  });
  disableButton: boolean = false;
  errorMessage: string = '';

  asFormControl = asFormControl;

  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth, private store: Store) {}

  ngOnInit(): void {
    this.loginForm.setValue({
      username: this.username,
      password: '',
    });

    this.loginForm.valueChanges.subscribe((value) => {
      this.updateUsername(value.username);
    });
  }

  async onSubmit(): Promise<void> {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    this.disableButton = true;
    this.errorMessage = '';

    try {
      await this.oktaAuth.idx.clearTransactionMeta();

      const authenticateResponse = await this.oktaAuth.idx.authenticate({
        username: this.loginForm.value.username,
        password: this.loginForm.value.password,
      });

      if (authenticateResponse.status === 'SUCCESS') {
        const { tokens } = authenticateResponse;

        if (!tokens) {
          throw new Error('Something went wrong. Please try again.');
        }

        this.store.dispatch(new SetUserSignInFlag(true)).subscribe(() => {
          setTimeout(async () => {
            await this.oktaAuth.tokenManager.setTokens(tokens);

            this.store.dispatch(new InitUser());
          }, 0);
        });
      } else if (authenticateResponse.status === 'PENDING') {
        throw new Error(
          authenticateResponse.messages
            ? authenticateResponse.messages[0].message
            : 'Something went wrong. Please try again.'
        );
      } else {
        throw new Error('Something went wrong. Please try again.');
      }
    } catch (err: any) {
      this.errorMessage = err.message;
      this.disableButton = false;
    }
  }
}
